export const apiurl = 'https://vacaydropadmin.sdssoftltd.co.uk'

// export const apiurl='https://vacaydropadminuat.sdsstaging.co.uk'
// https://stag.vacaydrop.com/admin/public